import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-exito',
  templateUrl: './form-exito.component.html',
  styleUrls: ['./form-exito.component.css']
})
export class FormExitoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
